import RequireData from "hooks/RequireData";
import React from "react";
import { ListGroup } from "react-bootstrap";
import teamMembersSelector from "selectors/teamMembers";
import teamMembersStatusSelector from "selectors/teamMembersStatus";
import TeamUserRow from "./TeamUserRow";
import styles from "./TeamDetailMembers.module.scss";
import classnames from "classnames";

interface Props {
    teamId: string;
    team: sage.model.ITeam | undefined;
}

const TeamDetailMembers: React.FC<Props> = ({ teamId, team }) => {
    const [members, status] = RequireData(
        teamMembersSelector(teamId),
        teamMembersStatusSelector(teamId),
        {
            type: "com.sage.actions.team.IFetchTeamMembers",
            teamId: teamId,
        } as sage.actions.team.IFetchTeamMembers
    );

    if (status === "error") {
        return <p>Error.</p>;
    }

    if (!members) {
        return <p>Loading...</p>;
    }

    return (
        <>
            <div
                className={classnames(
                    "row align-items-center",
                    styles.membersHeader
                )}
            >
                <div className="col">
                    <h5>Members</h5>
                </div>
            </div>
            <ListGroup>
                {members.map((u) => (
                    <TeamUserRow team={team} key={u.id} user={u} />
                ))}
            </ListGroup>
        </>
    );
};

export default TeamDetailMembers;
